// extracted by mini-css-extract-plugin
module.exports = {"scalingContainer":"_22iTsCZ9Z_wbfYcQX4U0Jm"};